/**
 * Created by luka on 23.02.2018.
 */

import {LOADING_SUBMIT_FAILED, SUBMIT_ALREADY_MISSED, SUBMIT_LOADING} from "../actions/types";
export function loadingSubmitFailed(state = false, action) {
    switch (action.type) {
        case LOADING_SUBMIT_FAILED:
            return action.error;
        default:
            return state;
    }
}
export function submitLoading(state = false, action) {
    switch (action.type) {
        case SUBMIT_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function submitAlreadyMissed(state = false, action) {
    switch (action.type) {
        case SUBMIT_ALREADY_MISSED:
            return action;
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/workout/SubmitReducer.js